module.exports = __webpack_public_path__ + "img/album_placeholder.807747ee.png";